<!--
 * @Author:
 * @LastEditTime: 2024-01-30 19:03:09
 * @Description: 新增、编辑模型
-->
<template>
  <div>
    <div v-if="!showText">
      <el-upload
        :disabled="disabled"
        :drag="drag"
        ref="upload"
        action="https://xx.yy.zz"
        :file-list="fileList"
        :limit="limit"
        :auto-upload="false"
        :on-change="onChange"
        :before-upload="beforeUpload"
        :multiple="multiple"
        :http-request="importListFile"
        :show-file-list="false"
        :on-exceed="handleExceed"
      >
        <template v-if="drag">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖拽到此处，或
            <em>点击上传</em>
          </div>
          <div v-if="tipShow" class="el-upload__tip" slot="tip">
            {{ tip }}
          </div>
        </template>
        <template v-if="!drag && copyFileList.length < limit">
          <el-button :disabled="disabled" size="small" type="primary">点击上传</el-button>
        </template>
      </el-upload>
      <div v-show="copyFileList.length" class="inline-block">
        <slot name="content">
          <div
            :key="item.id"
            v-for="item in copyFileList"
            class="w-490px p-0px px-4px mt-10px mb-5px hover:bg-$detailContentBg leading-28px flex justify-between items-center"
          >
            <div class="flex-1 truncate cursor-pointer" @click="onPreview(item)">
              <i class="iconfont icon-bg-file"></i> {{ item.name }}
            </div>
            <div class="max-w-50px">
              <span
                class="ml-5px mr-5px cursor-pointer"
                v-if="_.includes(imageList, _.last(_.split(item.name || item.fileName, '.')))"
                @click="viewFile(item)"
              >
                <i class="icon-bg-display iconfont text-14px"></i>
              </span>
              <span class="ml-5px cursor-pointer" v-if="!disabled" @click="beforeRemove(item)">
                <i
                  class="icon-line-close iconfont text-12px hover:text-$buttonDeleteBg hover:shadow"
                ></i>
              </span>
            </div>
          </div>
        </slot>
      </div>
    </div>
    <div v-else class="inline-block w-full min-h-30px flex items-center">
      <slot name="content">
        <div
          :key="index"
          v-for="(item, index) in copyFileList"
          class="p-0px hover:bg-slate-100 truncate"
        >
          <span
            class="cursor-pointer text-blue-500 underline decoration-1"
            @click="viewFile(item)"
            >{{ item.name }}</span
          >
        </div>
      </slot>
    </div>
    <el-image
      v-show="false"
      ref="elImage"
      :src="imgContent"
      :preview-src-list="[imgContent]"
    ></el-image>
  </div>
</template>
<script type="text/babel">
import { FileApi, TempFileApi } from '@wiz-api/file-management'
import { MaterialMediaApi } from '@wiz-api/material-management'
import { split, filter, map, assign, eq, find, head, isEmpty } from 'lodash'

const fileApi = new FileApi()
const tempFileApi = new TempFileApi()
const materialMediaApi = new MaterialMediaApi()

export default {
  name: 'formUpload',
  model: {
    prop: 'fileIds',
    event: 'change',
  },
  props: {
    // 是否只显示文本
    showText: {
      default: false,
    },
    // 文件数量
    limit: {
      default: 1,
    },
    // 是否多传
    multiple: {
      default: false,
    },
    // 文件大小不超过，单位m，默认100，
    maxSize: {
      type: Number,
      default: 100,
    },
    // 可上传文件类型
    accept: {
      type: Array,
      default: () => {
        return ['pdf', 'jpg', 'png']
        // 图片格式默认前4个
        // 'jpeg', 'gif', 'psd', 'bmp', 'tiff'
      },
    },
    // 文本提示是否显示
    tipShow: {
      type: Boolean,
      default: true,
    },
    // 查看
    disabled: {
      type: Boolean,
      disabled: false,
    },
    // 绑定数值
    fileIds: {
      type: String,
      default: '',
    },
    // 是否拖拽上传
    drag: {
      type: Boolean,
      default: true,
    },
    // 是否为临时文件上传
    isTemp: {
      type: Boolean,
      default: false,
    },
    // 文件列表附加信息 删除用
    fileMedias: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  computed: {
    tip() {
      return `只能上传${this.accept.join('、')}文件，且上传不超过${this.maxSize}M`
    },
  },
  data() {
    return {
      // fileList上传的时候会改变值，自己写个copyFileList
      fileList: [],
      copyFileList: [],
      // 图片预览信息
      imgContent: null,
      // 请求实例
      requestInstance: {},
      // 可查看文件类型
      imageList: ['jpg', 'png', 'jpg', 'jpeg', 'gif', 'psd', 'bmp', 'tiff'],
    }
  },
  created() {
    this.requestInstance = this.isTemp
      ? assign(tempFileApi, { upload: tempFileApi.upload })
      : fileApi
    if (this.fileIds) {
      this.fnGetFileList(split(this.fileIds, ','))
    } else {
      this.copyFileList = []
    }
  },
  watch: {
    fileIds(fileIds) {
      if (fileIds) {
        this.fnGetFileList(split(this.fileIds, ','))
      } else {
        this.fileList = []
        this.copyFileList = []
      }
    },
  },
  methods: {
    // 文件超出限制钩子
    handleExceed() {
      // 文件个数不一致判定为上一次上传失败，不计入有效文件数
      if (!isEmpty(this.fileList) && !eq(this.copyFileList?.length, this.fileList?.length)) {
        const file = head(this.fileList)
        this.onChange(null, file)
        return
      }
      this.$message.warning('文件个数超出限制')
    },
    beforeUpload(file) {
      const maxSize = file.maxSize / 1024 / 1024
      const name = file.name
      if (maxSize > this.maxSize) {
        this.$message.warning(`上传文件大小不能超过${this.maxSize}M`)
        return false
      }
      const fileSuffix = name.substring(name.lastIndexOf('.') + 1).toLowerCase()
      if (
        !this.accept
          .map((i) => {
            return i.toLowerCase()
          })
          .includes(fileSuffix)
      ) {
        this.$message.warning(`上传文件只能是${this.accept.join('、')}`)
        return false
      }
      return true
    },
    // 获取附件列表
    async fnGetFileList(fileIds) {
      this.fileList = []
      this.copyFileList = []
      fileIds.forEach(async (id) => {
        const [err, res] = await this.requestInstance.get(id)
        if (!err) {
          this.copyFileList.push(res)
          this.fileList.push(res)
        }
      })
    },
    // 附件，删除
    async fnDeleteFileReg() {
      const [err, res] = await this.requestInstance.callDelete(this.fileId)
      if (!err) {
        this.$message({
          message: '删除成功',
          type: 'success',
        })
        this.fileList = []
        this.$emit('change', '')
      }
    },
    async importListFile(params) {
      // 上传附件
      const [err, res] = await this.requestInstance.upload({
        files: [params.file],
        authLevel: 2,
      })
      if (!err) {
        this.$emit(
          'change',
          [...this.copyFileList, ...res]
            .map((i) => {
              return i.id
            })
            .join(',')
        )
        return
      }
      // 上传失败删除本次文件
      this.fileList = filter(this.fileList, (item) => {
        return !eq(item.uid, params.file.uid)
      })
    },
    onChange(file, fileList) {
      this.fileList = fileList
      this.$refs.upload.submit()
    },
    beforeRemove(file) {
      return this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: async (action) => {
          if (action === 'confirm') {
            const deleteFileItem = find(this.fileMedias, ['fileInfoId', file.id])
            // 删除新增未保存的文件 临时文件
            if (!deleteFileItem) {
              const [err, res] = await this.requestInstance.callDelete(file.id)
              if (!err) {
                this.copyFileList = filter(this.copyFileList, (i) => {
                  return i.id !== file.id
                })
              }
            } else {
              // 删除已保存的动效模型文件
              const [err, res] = await materialMediaApi.callDelete(deleteFileItem.id)
              if (!err) {
                this.copyFileList = filter(this.copyFileList, (i) => {
                  return i.id !== file.id
                })
              }
            }
            this.fileList = this.copyFileList
            this.$emit(
              'change',
              map(this.copyFileList, (i) => {
                return i.id
              }).join(',')
            )
          }
        },
      })
    },
    onPreview(file) {
      this.downLoadFile(file)
    },
    // 附件，下载
    async downLoadFile(file) {
      const [err, res] = await this.requestInstance.download(file.id, { returnType: 'Blob' })
      if (!err) {
        this.exportFile(res, file.name)
      }
    },
    // 下载文件
    exportFile(data, name) {
      const blob = new Blob([data], {
        type: 'application/pdf',
      })
      const blobUrl = window.URL.createObjectURL(blob)
      const templink = document.createElement('a')
      templink.style.display = 'none'
      templink.href = blobUrl
      templink.setAttribute('download', `${name}`)
      document.body.appendChild(templink)
      templink.click()
      document.body.removeChild(templink)
      window.URL.revokeObjectURL(blobUrl)
      this.$message({
        type: 'success',
        message: '下载成功!',
      })
    },
    // 查看文件
    async viewFile(file) {
      const [err, res] = await this.requestInstance.download(file.id, { returnType: 'Blob' })
      const strList = split(file.name, '.')
      const type = strList[strList.length - 1].toLowerCase()
      const typeMap = {
        pdf: 'application/pdf',
      }
      if (!typeMap[type] && !(this.imageList.indexOf(type) > -1)) {
        this.$message.warning('只支持pdf和图片预览')
        return
      }
      if (this.imageList.indexOf(type) > -1) {
        const [error, result] = await this.requestInstance.getFileContent(file.id)
        if (!error) {
          this.imgContent = `data:image/jpg;base64,${result.content}`
        }
        this.$refs.elImage.clickHandler()
        return
      }
      if (!err) {
        // this.exportFile(res, file.name)
        const blob = new Blob([res], {
          type: 'application/pdf',
        })
        const blobUrl = window.URL.createObjectURL(blob)
        const templink = document.createElement('a')
        templink.style.display = 'none'
        templink.href = blobUrl
        templink.setAttribute('target', '_blank')
        document.body.appendChild(templink)
        templink.click()
        document.body.removeChild(templink)
        window.URL.revokeObjectURL(blobUrl)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-upload__tip {
    margin: 0;
    line-height: 14px;
    color: #939696;
  }

  .el-form-item__content {
    line-height: 24px;
  }

  .el-dialog__body {
    padding-top: 0;
    height: calc(100% - 60px);
  }
}
</style>
